// extracted by mini-css-extract-plugin
export default {"forecast-items":"forecast_forecast-items__tOYMa","weekday":"forecast_weekday__gas3b"};